import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setMainHeading } from "../../../redux/modules/mainHeading/slice";
import PatientAccountsList from "./list";

export default function PatientAccounts() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setMainHeading("Patient Accounts"))
    }, [dispatch]);

    return (
        <PatientAccountsList />
    );
}
